var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-steps", {
    staticStyle: {
      padding: "0 10%",
      "margin-bottom": "40px"
    },
    attrs: {
      active: _vm.active
    }
  }, [_c("el-step", {
    attrs: {
      title: _vm.$t("信息文案"),
      icon: "el-icon-edit"
    },
    nativeOn: {
      click: function ($event) {
        return _vm.nextFun2(0);
      }
    }
  }), _c("el-step", {
    attrs: {
      title: _vm.$t("条款告知"),
      icon: "el-icon-s-order"
    },
    nativeOn: {
      click: function ($event) {
        return _vm.nextFun2(1);
      }
    }
  }), _c("el-step", {
    attrs: {
      title: _vm.$t("投保模版"),
      icon: "el-icon-tickets"
    },
    nativeOn: {
      click: function ($event) {
        return _vm.nextFun2(2);
      }
    }
  }), _c("el-step", {
    attrs: {
      title: _vm.$t("产品方案"),
      icon: "el-icon-s-grid"
    },
    nativeOn: {
      click: function ($event) {
        return _vm.nextFun2(3);
      }
    }
  })], 1), _vm.active == 0 ? _c("information", {
    attrs: {
      id: _vm.id,
      info: _vm.infoObj
    },
    on: {
      next: _vm.nextFun
    }
  }) : _vm._e(), _vm.active == 1 ? _c("notification", {
    attrs: {
      id: _vm.id,
      info: _vm.infoObj
    },
    on: {
      next: _vm.nextFun,
      prev: _vm.prevFun
    }
  }) : _vm._e(), _vm.active == 2 ? _c("rendering", {
    attrs: {
      id: _vm.id,
      info: _vm.infoObj
    },
    on: {
      prev: _vm.prevFun,
      info: _vm.getInfoFun,
      next: _vm.nextFun
    }
  }) : _vm._e(), _vm.active == 3 ? _c("plan-list", {
    attrs: {
      id: _vm.id,
      info: _vm.infoObj
    },
    on: {
      prev: _vm.prevFun,
      back: function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };